// ═══════════════════════════════════════
// UNIT-NOTE-PICKER — Dropdown sélecteur de note de référence (L:)
// ═══════════════════════════════════════

const OPTIONS = [
    { abc: '1/4',  symbol: '♩',  label: 'Noire'         },
    { abc: '1/8',  symbol: '♪',  label: 'Croche'        },
    { abc: '1/16', symbol: '𝅘𝅥𝅯', label: 'Double croche' },
];

// ── Positionnement & fermeture ────────────────────────────────────────────────

let _activeTriggerId = null;

function _position(triggerId) {
    const trigger = document.getElementById(triggerId);
    const dd      = document.getElementById('unit-note-picker-dropdown');
    if (!trigger || !dd) return;

    const rect = trigger.getBoundingClientRect();
    dd.style.top  = (rect.bottom + window.scrollY + 4) + 'px';
    dd.style.left = (rect.left   + window.scrollX)     + 'px';

    requestAnimationFrame(() => {
        const r = dd.getBoundingClientRect();
        if (r.right > window.innerWidth - 8) {
            dd.style.left = (window.innerWidth - r.width - 8) + 'px';
        }
        if (r.bottom > window.innerHeight - 8) {
            dd.style.top = (trigger.getBoundingClientRect().top + window.scrollY - r.height - 4) + 'px';
        }
    });
}

function _close() {
    const dd = document.getElementById('unit-note-picker-dropdown');
    if (dd) dd.style.display = 'none';
    _activeTriggerId = null;
}

// ── Rendu ─────────────────────────────────────────────────────────────────────

/**
 * @param {string}   currentValue  Valeur sélectionnée ('1/4', '1/8', '1/16') ou '' pour Auto
 * @param {string}   defaultValue  Valeur calculée automatiquement (affichée dans l'option Auto)
 * @param {Function} onCommit      Appelé avec la valeur abc choisie ('' = Auto)
 */
function _renderFor(currentValue, defaultValue, onCommit) {
    const dd = document.getElementById('unit-note-picker-dropdown');
    if (!dd) return;

    const autoOpt = OPTIONS.find(o => o.abc === defaultValue);
    const autoLabel = autoOpt ? `${autoOpt.symbol} ${defaultValue}` : defaultValue;

    let html = `<div class="unp-list">`;

    // Option Auto
    const autoSel = !currentValue ? ' unp-selected' : '';
    html += `<button class="unp-option${autoSel}" data-abc="">
        <span class="unp-symbol">—</span>
        <span class="unp-label">Auto <span class="unp-default">(${autoLabel})</span></span>
    </button>`;

    OPTIONS.forEach(({ abc, symbol, label }) => {
        const sel = currentValue === abc ? ' unp-selected' : '';
        html += `<button class="unp-option${sel}" data-abc="${abc}">
            <span class="unp-symbol">${symbol}</span>
            <span class="unp-label">${label} <span class="unp-abc">${abc}</span></span>
        </button>`;
    });

    html += `</div>`;
    dd.innerHTML = html;

    dd.querySelectorAll('.unp-option').forEach(btn => {
        btn.addEventListener('mousedown', e => {
            e.preventDefault();
            e.stopPropagation();
            onCommit(btn.dataset.abc);
            _close();
        });
    });
}

// ── Affichage du trigger ──────────────────────────────────────────────────────

function _triggerLabel(value, defaultValue) {
    if (!value) {
        const autoOpt = OPTIONS.find(o => o.abc === defaultValue);
        return autoOpt ? `${autoOpt.symbol} Auto` : 'Auto';
    }
    const opt = OPTIONS.find(o => o.abc === value);
    return opt ? `${opt.symbol} ${value}` : value;
}

// ── API publique ──────────────────────────────────────────────────────────────

/**
 * Init pour un trigger externe (modale).
 * @param {string}   triggerId     ID du bouton déclencheur
 * @param {string}   initialValue  Valeur initiale ('' = Auto, '1/8', etc.)
 * @param {string}   defaultValue  Valeur calculée selon M: (pour affichage)
 * @param {Function} onCommit      Appelé avec la nouvelle valeur ('' ou '1/4', '1/8', '1/16')
 */
export function initUnitNotePickerFor(triggerId, initialValue, defaultValue, onCommit) {
    let currentValue = initialValue || '';

    const trigger = document.getElementById(triggerId);
    if (trigger) trigger.textContent = _triggerLabel(currentValue, defaultValue);

    const fresh = trigger?.cloneNode(true);
    if (trigger && fresh) trigger.parentNode.replaceChild(fresh, trigger);

    fresh?.addEventListener('click', e => {
        e.stopPropagation();
        const dd = document.getElementById('unit-note-picker-dropdown');
        if (dd && dd.style.display === 'block' && _activeTriggerId === triggerId) {
            _close();
        } else {
            _activeTriggerId = triggerId;
            _renderFor(currentValue, defaultValue, (abc) => {
                currentValue = abc;
                const trig = document.getElementById(triggerId);
                if (trig) trig.textContent = _triggerLabel(currentValue, defaultValue);
                onCommit(abc);
            });
            _position(triggerId);
            const dd2 = document.getElementById('unit-note-picker-dropdown');
            if (dd2) dd2.style.display = 'block';
        }
    });
}

/**
 * Met à jour l'affichage du trigger (ex: quand M: change et que le défaut change).
 */
export function updateUnitNotePickerDefault(triggerId, currentValue, defaultValue) {
    const trig = document.getElementById(triggerId);
    if (trig) trig.textContent = _triggerLabel(currentValue, defaultValue);

    // Si le dropdown est ouvert sur ce trigger, le re-rendre
    const dd = document.getElementById('unit-note-picker-dropdown');
    if (dd && dd.style.display === 'block' && _activeTriggerId === triggerId) {
        // On relit onCommit depuis le dernier renderFor — on ferme simplement
        // car on n'a pas de ref au callback ; l'appelant peut rappeler initUnitNotePickerFor
        _close();
    }
}

// Fermeture globale au clic extérieur (à appeler une seule fois au DOMContentLoaded)
export function initUnitNotePicker() {
    document.addEventListener('mousedown', e => {
        const dd = document.getElementById('unit-note-picker-dropdown');
        if (!dd) return;
        const activeTrigger = _activeTriggerId ? document.getElementById(_activeTriggerId) : null;
        if (!dd.contains(e.target) && e.target !== activeTrigger) _close();
    });
}